var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg83(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.425 0.151229L17.015 3.14423C15.949 3.06223 15.17 3.2809 14.678 3.80023C14.186 4.31956 13.8853 5.01656 13.776 5.89123C13.6667 6.7659 13.6393 7.7089 13.694 8.72023H17.425V17.3712H10.414V7.08023C10.414 4.56556 11.0427 2.67956 12.3 1.42223C13.5847 0.164897 15.293 -0.25877 17.425 0.151229ZM7.011 0.151229L6.601 3.14423C5.535 3.06223 4.756 3.2809 4.264 3.80023C3.772 4.31956 3.47133 5.01656 3.362 5.89123C3.25267 6.7659 3.22533 7.7089 3.28 8.72023H7.011V17.3712H0V7.08023C0 4.56556 0.628667 2.67956 1.886 1.42223C3.17067 0.164897 4.879 -0.25877 7.011 0.151229Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg83);
export default __webpack_public_path__ + "static/media/svg83.c954837ccae9fca34ca4c316e86eb3e7.svg";
export { ForwardRef as ReactComponent };